import NewSelectInput from "../../components/NewSelectInput";

type Props = {
  register: any;
  errors: any;
  clearErrors?: any;
  setValue: (name: string, value: any) => void;
  watch: any;
  control: any;
};

const DRIVER_ASSIGNMENT_MODE = [
  { id: 1, value: "SHARED", text: "SHARED" },
  { id: 2, value: "DEDICATED", text: "DEDICATED" },
  { id: 3, value: "BRANCH SPECIFIC", text: "BRANCH SPECIFIC" },
];

const AddDriverAssigmentTypeModal = ({
  register,
  errors,
  clearErrors,
  setValue,
  watch,
}: Props) => {
  return (
    <div className="w-full py-4 px-6 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-tr-[30px]">
      <div className="md:w-[550px] sm:w-[450px]">
        <NewSelectInput
          name="driverAssignmentType"
          label="Driver Assignment"
          className="col-span-2"
          placeholder=""
          selectOptions={DRIVER_ASSIGNMENT_MODE}
          register={register}
          validation={{ required: "Driver Assignment is required" }}
          value={watch("driverAssignmentType")?.toUpperCase()}
          setValue={(val: string) => {
            setValue("driverAssignmentType", val);
          }}
          error={errors?.driverAssignmentType}
          clearErrors={clearErrors}
        />
      </div>
    </div>
  );
};

export default AddDriverAssigmentTypeModal;
